import { CasRenderBoolTrueFalse, CasTable } from 'src/compass/shared/components';

export default function AgenciesTab() {
  return (
    <CasTable
      entity="Sce/Claims/InsAgency"
      columns={[
        { field: 'name' },
        { field: 'agencyNbr', label: 'Agency#' },
        { field: 'claimsSharepointSite', label: 'Sharepoint Site' },
        { field: 'claimsSharepointRoot', label: 'Sharepoint Root' },
        { field: 'isActive', label: 'Active', render: CasRenderBoolTrueFalse },
      ]}
      includeExport={false}
    />
  );
}
